<template>
  <div id="options" class="adminActions">
    <button id="buttonOptions" class="btn adminButton" href="javascript:">
      <img src="../assets/icon.png" alt="Logo">
    </button>
    <div class="adminButtons">
      <button title="Pausar o LeBot p/ este cliente" id="pause" class="btn shadow" v-show="dados.status === 1" @click="setStatus(2)">
        <svg enable-background="new 0 0 39.989 39.989" version="1.1" viewBox="0 0 39.989 39.989" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" fill="#F6C23E"><path d="M19.995,0C8.952,0,0,8.952,0,19.994c0,11.043,8.952,19.995,19.995,19.995s19.995-8.952,19.995-19.995  C39.989,8.952,31.037,0,19.995,0z M18.328,26.057c0,0.829-0.671,1.5-1.5,1.5s-1.5-0.671-1.5-1.5V14.724c0-0.829,0.671-1.5,1.5-1.5  s1.5,0.671,1.5,1.5V26.057z M24.661,26.057c0,0.829-0.671,1.5-1.5,1.5s-1.5-0.671-1.5-1.5V14.724c0-0.829,0.671-1.5,1.5-1.5  s1.5,0.671,1.5,1.5V26.057z"/></svg>
      </button>
      <button title="Ativar o LeBot p/ este cliente" id="play" class="btn shadow" v-show="dados.status !== 1" @click="setStatus(1)">
        <svg enable-background="new 0 0 496 496" version="1.1" viewBox="0 0 496 496" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><path d="M496,248c0,136.8-111.2,248-248,248S0,384.8,0,248S111.2,0,248,0S496,111.2,496,248z" fill="#4762b4"/><path d="M248,0c136.8,0,248,111.2,248,248S384.8,496,248,496" fill="#506eca"/><path d="m72.8 72.8c96.8-96.8 253.6-96.8 350.4 0s96.8 253.6 0 350.4" fill="#597BE1"/><path d="m212.8 360.8c-1.6 0-4-0.8-5.6-1.6-4-1.6-7.2-6.4-7.2-10.4v-149.6c0-4 3.2-8.8 7.2-10.4s8.8-1.6 12.8 0.8l101.6 75.2c3.2 2.4 4.8 5.6 4.8 9.6s-1.6 7.2-4.8 9.6l-101.6 75.2c-2.4 0.8-4.8 1.6-7.2 1.6z" fill="#4762b4"/><path d="m212.8 334.4c-1.6 0-4-0.8-5.6-1.6-4-1.6-7.2-6.4-7.2-10.4v-149.6c0-4 3.2-8.8 7.2-10.4s8.8-1.6 12.8 0.8l101.6 75.2c3.2 2.4 4.8 5.6 4.8 9.6s-1.6 7.2-4.8 9.6l-101.6 75.2c-2.4 0.8-4.8 1.6-7.2 1.6z" fill="#fff"/></svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusToggle",
  props: ['dados'],
  data() {
    return {
      show: false,
      btnPause: false,
      btnPlay: false,
      btnStop: false
    }
  },

  methods: {
    init(dados) {
      this.btnPlay = dados.status !== 1;
      this.btnPause = dados.status !== 2;
      this.btnStop = dados.status !== 3;
    },

    setStatus(status) {
      this.$emit('evento', status);
    }
  },

  mounted() {
    this.init(this.dados);
  },

  watch: {
    dados(val) {
      this.init(val);
    }
  }
}
</script>

<style scoped>
.adminActions {
  position: relative;
  margin-left: 8px;
  /*right: 14px;*/
  /*bottom: 76px;*/
}

.adminButton {
  height: 45px;
  width: 45px;
  display: block;
  color: #fff;
  text-align: center;
  position: relative;
  z-index: 1;
  overflow: hidden;
  padding: 0;
  outline: none!important;
}

.paused {
  box-shadow: 1px 1px 14px red;
  background-color: red;
  border-radius: 50%;
}

.adminButton img {
  width: 38px;
  height: 38px;
  object-fit: cover;
}

.adminButton i {
  font-size: 24px;
}

.adminButton:focus + .adminButtons button {
  visibility: visible;
  opacity: 1;
}

.adminButtons {
  position: absolute;
  width: 100%;
  bottom: 135%;
  text-align: center;
}

.adminButtons button {
  padding: 0;
  display: block;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  text-decoration: none;
  margin: 16px auto 0;
  line-height: 1.15;
  color: #fff;
  opacity: 0;
  visibility: hidden;
  position: relative;
  background-color: white;
  border: 0;
}

.adminButtons button > img {
  display: block;
  margin: 0 auto;
}

.adminButtons button:hover {
  transform: scale(1.05);
}

.adminButtons button:nth-child(1) {
  transition: opacity .2s ease-in-out .3s, transform .15s ease-in-out;
}

.adminButtons button:nth-child(2) {
  transition: opacity .2s ease-in-out .25s, transform .15s ease-in-out;
}

.adminButtons button:nth-child(3) {
  transition: opacity .2s ease-in-out .2s, transform .15s ease-in-out;
}

.adminButtons button:nth-child(3) > img {
  display: block;
  margin: auto;
}

.adminButtons button:nth-child(4) {
  transition: opacity .2s ease-in-out .15s, transform .15s ease-in-out;
}

.adminActions button i {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.adminToggle {
  -webkit-appearance: none;
  position: absolute;
  border-radius: 50%;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background-color: transparent;
  border: none;
  outline: none;
  z-index: 2;
  transition: box-shadow .2s ease-in-out;
  box-shadow: 0 3px 5px 1px rgba(51, 51, 51, .3);
}

.adminToggle:hover {
  box-shadow: 0 3px 6px 2px rgba(51, 51, 51, .3);
}

.adminToggle:disabled~#buttonOptions {
  opacity: 0.5;
  cursor: not-allowed;
}

.load {
  background-color: #ff6347;
  font-family: 'Lato', sans-serif;
  color: #fffeee;
  display: inline-block;
  width: 30px;
  height: 30px;
  border: 5px solid #fff;
  border-radius: 100%;
  border-top: 5px solid transparent;
  -webkit-animation: load-animate infinite linear 1s;
  animation: load-animate infinite linear 1s;
}

@-webkit-keyframes load-animate {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
    opacity: 0.35;
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load-animate {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
    opacity: 0.35;
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

</style>